export const allChildrenHaveBrandLogos = (children: MenuItem[]): boolean => {
  if (!children || children.length === 0) return false;
  return children.every(
    child => child.imageUrl && child.imageUrl.includes('CRMLOGO')
  );
};

/* categories with brands icons should be shown at the bottom of the sub menu on mobile */
export const sortBrandsIconCategories = (items: MenuItem[]) => {
  return [
    ...items.filter(item => !allChildrenHaveBrandLogos(item.child)),
    ...items.filter(item => allChildrenHaveBrandLogos(item.child)),
  ];
};
